<template>
    <div class="d-inline-block position-relative">
        <div v-click-outside="hide" @mouseleave="hide($event)" class="dropdown flex-fill d-inline-block">
            <a v-bind:class="['dropdown-toggle', togglerClass]" @click.stop="show" @mouseenter="show">
                <slot name="label"></slot>
                <transition name="fade">
                    <div v-show="menuVisible && !menuDisabled">
                        <div v-bind:class="['arrow', 'distance-y-' + distanceY]"></div>
                        <div v-bind:class="['dropdown-nav', 'basic-shadow', 'arrow-' + arrow, 'distance-y-' + distanceY]">
                            <div class="dropdown-filler"></div>
                            <slot></slot>
                        </div>
                    </div>
                </transition>
            </a>
        </div>
        <slot name="no-hover">
        </slot>
    </div>
</template>

<script>
    export default {
        name: "dropdown-nav",
        props: {
            label: String,
            menuDisabled: {
                type: Boolean,
                default: false
            },
            arrow: {
                type: String,
                default: "center"
            },
            distanceY: {
                type: String,
                default: 'md'
            },
            togglerClass: {
                type: String,
                default: ""
            }
        },
        data: function () {
            return {
                menuVisible: false
            }
        },
        methods: {
            show() {
                if(!this.menuDisabled) {
                    this.menuVisible = true;
                }
            },
            forceHide() {
                this.menuVisible = false;
            },
            hide(e) {
                if (e && e.relatedTarget) {
                    this.menuVisible = false;
                }
            }
        },
        watch: {
            '$route': function () {
                this.forceHide();
            },
            menuVisible: function (val) {
                this.$emit('menuVisible', val);
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .dropdown {
        z-index: 999;

        .dropdown-filler {
            position: absolute;
            width: 100%;
            height: 40px;
            z-index: 2;
            top: -40px
        }

        .dropdown-button {
            position: relative;
        }

        .arrow {

            position: absolute;
            display: block;
            left: 50%;
            width: auto;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
            z-index: 999;

            &.distance-y-md {
                bottom: -40px;
            }

            &.distance-y-sm {
                bottom: -20px;
            }

            &:before {
                margin-left: -6px;
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-bottom-color: white;
            }
        }

        .dropdown-nav {
            background: white;
            z-index: 998;
            position: absolute;
            display: flex;
            cursor: default;

            &.distance-y-md {
                margin-top: 40px;
            }

            &.distance-y-sm {
                margin-top: 20px;
            }

            &.arrow-right {
                right: 0;
            }

            &.arrow-center {
                left: 50%;
                width: auto;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
            }
        }
    }


</style>